import React from 'react'
import HtmlRenderer from '../components/HtmlRender'

function PlaceitPrivacyPolicy() {
  const htmlContent = `
<style>
  [data-custom-class='body'], [data-custom-class='body'] * {
    background: transparent !important;
  }
  [data-custom-class='title'], [data-custom-class='title'] * {
    font-family: Arial !important;
    font-size: 26px !important;
    color: #000000 !important;
  }
  [data-custom-class='subtitle'], [data-custom-class='subtitle'] * {
    font-family: Arial !important;
    color: #595959 !important;
    font-size: 14px !important;
  }
  [data-custom-class='heading_1'], [data-custom-class='heading_1'] * {
    font-family: Arial !important;
    font-size: 19px !important;
    color: #000000 !important;
  }
  [data-custom-class='heading_2'], [data-custom-class='heading_2'] * {
    font-family: Arial !important;
    font-size: 17px !important;
    color: #000000 !important;
  }
  [data-custom-class='body_text'], [data-custom-class='body_text'] * {
    color: #595959 !important;
    font-size: 14px !important;
    font-family: Arial !important;
  }
  [data-custom-class='link'], [data-custom-class='link'] * {
    color: #3030F1 !important;
    font-size: 14px !important;
    font-family: Arial !important;
    word-break: break-word !important;
  }
</style>

<div data-custom-class="body">
  <div>
    <strong>
      <span style="font-size: 26px;">
        <span data-custom-class="title">POLÍTICA DE PRIVACIDAD</span>
      </span>
    </strong>
  </div>
  <br/>
  <div>
    <span style="color: rgb(127, 127, 127);">
      <strong>
        <span style="font-size: 15px;">
          <span data-custom-class="subtitle">Última actualización: 29 de abril de 2025</span>
        </span>
      </strong>
    </span>
  </div>
  <br/><br/>
  <div style="line-height: 1.5;">
    <span style="color: rgb(89, 89, 89); font-size: 15px;" data-custom-class="body_text">
      Esta Política de Privacidad para <strong>PlaceIt</strong> describe cómo y por qué podemos recopilar, almacenar, usar y/o compartir tu información cuando utilizas nuestros servicios,
      tales como cuando:
    </span>
  </div>
  <ul>
    <li style="line-height: 1.5;">
      <span style="font-size: 15px; color: rgb(89, 89, 89);" data-custom-class="body_text">
        Visitas nuestro sitio web oficial en
        <a href="https://placeitmx.com" target="_blank" class="link">https://placeitmx.com</a>
        o cualquier otro sitio de PlaceIt que enlace a esta política de privacidad.
      </span>
    </li>
    <li style="line-height: 1.5;">
      <span style="font-size: 15px; color: rgb(89, 89, 89);" data-custom-class="body_text">
        Descargas y usas nuestra aplicación móvil <strong>PlaceIt</strong> (disponible en tiendas como Google Play o App Store) que haga referencia a esta política.
      </span>
    </li>
    <li style="line-height: 1.5;">
      <span style="font-size: 15px; color: rgb(89, 89, 89);" data-custom-class="body_text">
        Interactúas con nosotros en otros aspectos relacionados con ventas, marketing o eventos.
      </span>
    </li>
  </ul>

  <div style="line-height: 1.5;">
    <span style="font-size: 15px;" data-custom-class="body_text">
      <strong>¿Preguntas o inquietudes?</strong> Leer esta política de privacidad te ayudará a entender tus derechos y opciones en materia de protección de datos.
      Si no estás de acuerdo con nuestras prácticas, por favor no uses nuestros Servicios.
      Si aún tienes dudas o comentarios, contáctanos en
      <strong>soporteplaceit@gmail.com</strong>.
    </span>
  </div>
  <br/><br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        1. ¿QUÉ INFORMACIÓN RECOPILAMOS?
      </span>
    </strong>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <span style="font-size: 15px;" data-custom-class="heading_2"><strong>Información que nos proporcionas voluntariamente</strong></span>
  </div>
  <br/>

  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px; color: rgb(89, 89, 89);">
      <em>En resumen:</em> Recopilamos la información personal que nos proporcionas directamente cuando te registras o usas nuestras funciones.
    </span>
  </div>
  <br/>

  <div data-custom-class="body_text" style="line-height: 1.5;">
    <span style="font-size: 15px; color: rgb(89, 89, 89);">
      Los datos personales que recopilamos dependen del contexto de tus interacciones con PlaceIt, las elecciones que hagas, así como los productos y funcionalidades que utilices.
      Esto puede incluir:
    </span>
  </div>
  <ul>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Nombre completo y datos de contacto (correo electrónico, teléfono, etc.).</span></li>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Información de pago (tarjeta de crédito/débito, cuenta bancaria, etc.) si realizas transacciones en la plataforma.</span></li>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Dirección postal y facturación cuando sea necesario.</span></li>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Datos de espacios o servicios que ofreces (como anfitrión o proveedor), incluyendo ubicaciones, fotos, precios y disponibilidad.</span></li>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Historiales de reservas, transacciones y comunicaciones realizadas a través de la plataforma.</span></li>
    <li style="line-height: 1.5;"><span style="font-size: 15px;" data-custom-class="body_text">Otros datos que decidas compartir, por ejemplo, al completar tu perfil o al enviarnos consultas.</span></li>
  </ul>
  <br/>

  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px; color: rgb(89, 89, 89);">
      <strong>Información recopilada automáticamente</strong>. También obtenemos automáticamente cierta información técnica cuando navegas o usas nuestra app,
      como tu dirección IP, tipo de dispositivo, sistema operativo, identificadores de dispositivos, información de ubicación aproximada y datos de uso (páginas visitadas, acciones en la app, etc.).
      Esto se realiza, por ejemplo, mediante cookies y tecnologías similares.
    </span>
  </div>

  <br/>
  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        2. ¿CÓMO PROCESAMOS TU INFORMACIÓN?
      </span>
    </strong>
  </div>
  <br/>
  <div data-custom-class="body_text" style="line-height: 1.5;">
    <span style="font-size: 15px;">
      <em>En resumen:</em> Utilizamos tu información para proveer y mejorar nuestros servicios, comunicarnos contigo, cumplir con requerimientos legales y prevenir fraudes.
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Proporcionar y gestionar la plataforma de reserva de espacios y servicios para eventos (autenticación, soporte, notificaciones, etc.).
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Facilitar la conexión entre invitados (buscando espacios), anfitriones (ofreciendo espacios) y proveedores de servicios.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Procesar pagos y gestionar las transacciones entre usuarios de la plataforma.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Realizar análisis y estadísticas para comprender y mejorar la experiencia de usuario.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Prevenir actividades ilícitas y fraudes, detectar violaciones a nuestros términos y condiciones, y garantizar la seguridad de la plataforma.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Enviar comunicaciones relacionadas con el servicio, actualizaciones y ofertas relevantes.
      </span>
    </li>
  </ul>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        3. ¿QUÉ BASES LEGALES APLICAN PARA EL TRATAMIENTO?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px; color: rgb(89, 89, 89);">
      De acuerdo con la normativa aplicable en México (como la Ley Federal de Protección de Datos Personales en Posesión de Particulares),
      y dependiendo de tu ubicación, nos basamos en las siguientes bases legales para procesar tus datos:
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Tu consentimiento</strong>: Cuando aceptas expresamente el tratamiento de tus datos, por ejemplo, al registrarte.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Ejecución de un contrato</strong>: Para cumplir con los servicios que has solicitado (reservas, pagos, etc.).
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Interés legítimo</strong>: Cuando el procesamiento es necesario para mejorar nuestros servicios o proteger la plataforma.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Obligación legal</strong>: Cuando debemos cumplir con requerimientos legales, fiscales o regulatorios.
      </span>
    </li>
  </ul>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        4. ¿CUÁNDO Y CON QUIÉN COMPARTIMOS TU INFORMACIÓN?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      <em>En resumen:</em> Podemos compartir información con proveedores externos confiables para procesar datos en nuestro nombre, así como entre usuarios de la plataforma para facilitar las reservas.
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Entre usuarios de la plataforma</strong>: Para facilitar la conexión entre invitados, anfitriones y proveedores de servicios.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Proveedores de servicios tecnológicos</strong>: Alojamiento en la nube, pasarelas de pago, servicios de analítica y herramientas de marketing.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Afiliados y socios</strong>: Podemos compartir información con empresas afiliadas o socios comerciales cuando sea necesario para el funcionamiento de la plataforma.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Obligaciones legales</strong>: Podríamos divulgar datos para cumplir con la ley, responder a procesos judiciales o proteger los derechos,
        propiedad o seguridad de PlaceIt, nuestros usuarios u otros.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Transferencias empresariales</strong>: En caso de fusiones, adquisiciones o venta de activos, tus datos podrían ser parte de la transacción.
      </span>
    </li>
  </ul>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        5. ¿CUÁNTO TIEMPO CONSERVAMOS TUS DATOS?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Conservamos tu información personal solo mientras sea necesaria para cumplir los propósitos descritos o mientras la ley lo exija.
      Esto generalmente incluye:
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Datos de cuenta y perfil: Mientras mantengas una cuenta activa con nosotros.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Historial de transacciones y reservas: Hasta por 5 años después de completadas (por requisitos fiscales y legales).
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Comunicaciones con soporte: Hasta 2 años después de resolver la consulta.
      </span>
    </li>
  </ul>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Una vez que los datos ya no sean requeridos, los eliminaremos o anonimizaremos de forma segura.
    </span>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        6. ¿CÓMO PROTEGEMOS TU INFORMACIÓN?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Implementamos medidas de seguridad técnicas, administrativas y físicas diseñadas para proteger tus datos personales, que incluyen:
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Encriptación de datos sensibles (como información de pago).
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Acceso restringido a información personal dentro de nuestra organización.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Monitoreo de seguridad y detección de amenazas.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Verificación de identidad para prevenir accesos no autorizados.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        Evaluaciones periódicas de seguridad de nuestros sistemas.
      </span>
    </li>
  </ul>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Aunque nos esforzamos por proteger tu información, ningún método de transmisión o almacenamiento es 100% seguro. Por lo tanto, no podemos garantizar su seguridad absoluta.
    </span>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        7. ¿CUÁLES SON TUS DERECHOS DE PRIVACIDAD?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Dependiendo de tu ubicación geográfica, tienes ciertos derechos relacionados con tu información personal. En México, según la Ley Federal de Protección de Datos Personales en Posesión de Particulares, estos derechos incluyen:
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Acceso</strong>: Derecho a conocer qué datos personales tenemos sobre ti.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Rectificación</strong>: Derecho a solicitar la corrección de datos inexactos o incompletos.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Cancelación</strong>: Derecho a solicitar la eliminación de tus datos de nuestros registros.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Oposición</strong>: Derecho a oponerte al uso de tus datos para fines específicos.
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Revocar consentimiento</strong>: Derecho a retirar tu autorización para el tratamiento de tus datos.
      </span>
    </li>
  </ul>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Para ejercer estos derechos, contacta a nuestro Departamento de Protección de Datos en <strong>soporteplaceit@gmail.com</strong>.
      Responderemos a tu solicitud dentro de los plazos establecidos por la ley aplicable.
    </span>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        8. CONTROLES PARA FUNCIONES DO-NOT-TRACK
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      La mayoría de los navegadores web y dispositivos móviles incluyen funciones que te permiten indicar que no deseas ser "rastreado" en línea.
      Actualmente, no respondemos a señales de "Do-Not-Track" o mecanismos similares.
      Si esta práctica cambia en el futuro, actualizaremos esta política de privacidad.
    </span>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        9. ¿REALIZAMOS ACTUALIZACIONES A ESTA POLÍTICA?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Podemos actualizar esta política de privacidad periódicamente para reflejar cambios en nuestras prácticas, servicios o la legislación aplicable.
      Te notificaremos sobre cualquier cambio sustancial publicando la nueva política en nuestra plataforma, 
      y modificando la fecha de "última actualización" en la parte superior.
      Te recomendamos revisar esta política regularmente para mantenerte informado sobre cómo protegemos tu información.
    </span>
  </div>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        10. ¿CÓMO PUEDES CONTACTARNOS SOBRE ESTA POLÍTICA?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Si tienes preguntas o comentarios sobre esta política de privacidad, puedes contactarnos en:
    </span>
  </div>
  <br/>
  <ul>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Correo electrónico</strong>: soporteplaceit@gmail.com
      </span>
    </li>
    <li>
      <span style="font-size: 15px;" data-custom-class="body_text">
        <strong>Dirección postal</strong>: Calle Benito Juárez 136 colonia Modelo, Hermosillo, Sonora, México, 83190
      </span>
    </li>
  </ul>
  <br/>

  <div style="line-height: 1.5;">
    <strong>
      <span style="font-size: 15px;" data-custom-class="heading_1">
        11. ¿CÓMO PUEDES REVISAR, ACTUALIZAR O ELIMINAR LOS DATOS QUE RECOPILAMOS?
      </span>
    </strong>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Tienes derecho a solicitar acceso, corrección o eliminación de tu información personal.
      Puedes hacerlo a través de la configuración de tu cuenta en nuestra plataforma o contactándonos directamente.
      Responderemos a tu solicitud dentro de los plazos establecidos por las leyes aplicables.
    </span>
  </div>
  <br/>
  <div style="line-height: 1.5;" data-custom-class="body_text">
    <span style="font-size: 15px;">
      Si resides en México, tienes derechos específicos sobre tus datos personales bajo la Ley Federal de Protección de Datos Personales en Posesión de Particulares.
      Para mayor información sobre cómo ejercer tus derechos, contacta a nuestro Departamento de Protección de Datos en <strong>soporteplaceit@gmail.com</strong>.
    </span>
  </div>
</div>
`;

  return (
    <div className="max-w-3xl mx-auto p-4">
      <HtmlRenderer htmlContent={htmlContent} />
    </div>
  );
}

export default PlaceitPrivacyPolicy;


